"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MagicWandIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.125 3.625l.438-.875.875-.437-.875-.438L7.125 1l-.437.875-.875.438.875.437.437.875zm-3.937 1.75l.729-1.458 1.458-.73-1.458-.729L3.187 1 2.46 2.458 1 3.188l1.459.729.729 1.458zm9.625 3.5l-.73 1.458-1.458.73 1.459.729.729 1.458.729-1.458 1.458-.73-1.458-.729-.73-1.458zm1.93-5.298l-2.32-2.32a.87.87 0 00-1.237 0l-9.93 9.93a.875.875 0 000 1.237l2.32 2.32a.872.872 0 001.238 0l9.93-9.93a.874.874 0 000-1.237zM10.83 6.563L9.437 5.171l2.368-2.368 1.392 1.392-2.368 2.368z"
  })))
});
MagicWandIcon.displayName = 'MagicWandIcon';
var _default = exports.default = MagicWandIcon;